import BaseOverlay from '../_base-overlay';
import Icon, { RoundedIcon } from 'shared/components/icon/icon';
import { GenericButton } from 'shared/components/button/button';


export default class OverlayStripBase extends BaseOverlay {

  static displayName = 'OverlayStripBase';

  static propTypes = {
    selectNextVideo: React.PropTypes.func,
    areAllVideosVisible: React.PropTypes.bool,
    toggleVisibilityAllVideos: React.PropTypes.func,
    togglePause: React.PropTypes.func,
    showChannelInfo: React.PropTypes.func,
  };

  static defaultProps = {
    selectNextVideo: _.noop,
    toggleVisibilityAllVideos: _.noop,
    togglePause: _.noop,
    showChannelInfo: _.noop,
  };

  stopPropagation(event) {
    event.stopPropagation();
  }

  get preview() {
    const previewText = this.previewText;

    if (!previewText) {
      return null;
    }

    return (
      <span styleName="preview-text">
        ({previewText})
      </span>
    );
  }

  get playButton() {
    const playButtonText = this.playButtonText;

    if (!playButtonText) {
      return null;
    }

    return (
      <a href=""
         styleName="button play-button"
         onClick={this.playSelectedVideo}
         className="qa-widget-overlay-play-button">
        <RoundedIcon styleName="icon play-icon"
                     name="arrow-right-filled" />
        <span styleName="text">
          {playButtonText}
        </span>
      </a>
    );
  }

  get playNextButton() {
    const playNextButtonText = this.playNextButtonText;

    if (!playNextButtonText) {
      return null;
    }

    return (
      <GenericButton styleName="button"
                     className="qa-widget-player-play-next-button"
                     onClick={this.playNextVideo}>
        <span styleName="text">
          {playNextButtonText}
        </span>
        <Icon styleName="icon next-icon"
              name="arrow-right" />
      </GenericButton>
    );
  }

  get subscribeButton() {
    const subscribeButtonText = this.subscribeButtonText;

    if (!subscribeButtonText) {
      return null;
    }

    return (
      <a href=""
         styleName="button"
         className="qa-widget-overlay-subscribe-button"
         onClick={this.openSubscription}>
        <span styleName="text">
          {subscribeButtonText}
        </span>
      </a>
    );
  }

  get purchaseButton() {
    const purchaseButtonText = this.purchaseButtonText;

    if (!purchaseButtonText) {
      return null;
    }

    return (
      <a href=""
         styleName="button"
         onClick={this.openPurchase}
         className="qa-widget-overlay-buy-from-button">
        <span styleName="text">
          {purchaseButtonText}
        </span>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/strip/strip-base.js